import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SAPAMOUNTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('description', 'Entity.SapAmountType.Description')
    .minLength(1)
    .maxLength(100)
    .required()
    .build(),
  FieldBuilder.text('code', 'Entity.SapAmountType.Code')
    .minLength(1)
    .maxLength(1)
    .required()
    .build(),
];

export const SAPAMOUNTTYPE_CONFIG = {
  entityName: 'SapAmountType',
  localizationKey: 'Controlling::Entity.SapAmountType',
  fields: SAPAMOUNTTYPE_FIELDS,
  permission: 'ControllingSap.SapAmountTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
